module.exports = __webpack_public_path__ + "static/media/french-language-sphere.c3ba9ac5.svg";